module.exports = "/_next/static/resources/bouquet-88faa3d858f2731417dcb8b5ef6a9ba4.png";